import { Box, Grid, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Button } from "@mui/material";
import { useState } from "react";
import { groupPendingEnroEvent } from "../../../../_events/orders/find_order.event";
import { message } from "antd";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const ModalPending = () => {

    const [ info, setInfo ] = useState({ pending: [], open: false });

    const showModal = () => {
        setInfo({
            ...info,
            open: true
        });
        groupPendingEnroEvent()
        .then(json => {
            setInfo({
                pending: json.list,
                open: true
            });
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const closeModal = () => {
        setInfo({
            pending: [],
            open: false
        });
    }

    return (
        <div>
            <Button variant='contained' onClick={() => showModal()}>Ver Pendientes</Button>
            <Modal
                open={info.open}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container spacing={1}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Referencia</TableCell>
                                        <TableCell>Cantidad blancos (MTS)</TableCell>
                                        <TableCell>Cantidad negros (MTS)</TableCell>
                                        <TableCell>Cantidad 900 (MTS)</TableCell>
                                        <TableCell>Cantidad colores (MTS)</TableCell>
                                    </TableRow>
                                </TableHead>
                            </Table>
                            <div style={{ height: '500px', overflowY: 'auto' }}>
                            <Table>
                                <TableBody>
                                    {info.pending.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{item?.productref}</TableCell>
                                            <TableCell>{item?.totalwhite_mt+( item.totalmeterconversion &&  item.totalkiloconversion ?  ((item.totalwhite_kg * item.totalmeterconversion)/item.totalkiloconversion) :0 )   }</TableCell>
                                            <TableCell>{item?.totalblack_mt+( item.totalmeterconversion &&  item.totalkiloconversion ?   ((item.totalblack_kg * item.totalmeterconversion)/item.totalkiloconversion) : 0)  }</TableCell>
                                            <TableCell>{item?.total900_mt+( item.totalmeterconversion &&  item.totalkiloconversion ? ((item.total900_kg * item.totalmeterconversion)/item.totalkiloconversion) : 0 )   }</TableCell>
                                            <TableCell>{item?.totalcolors_mt+( item.totalmeterconversion &&  item.totalkiloconversion ? ((item.totalcolors_kg* item.totalmeterconversion)/item.totalkiloconversion) : 0) }</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>                            
                            </Table>
                            </div>
                        </TableContainer>
                    </Grid>
                </Box>
            </Modal>
        </div>
    )
}

export default ModalPending;
